import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useLang } from '../../hooks/useLang';
import { TimeColumns } from '../charts/Charts';
import { formatMinutes } from '../charts/chartTheme';

// The dashboard's only chart: two weeks of study time, no controls. Anyone
// who wants a different window is one click from Analytics, where the range
// picker lives.
const ActivityStrip = ({ analytics }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  const days = analytics?.dailyActivity || [];
  const total = analytics?.totalMinutes || 0;
  const activeDays = analytics?.activeDays || 0;

  const data = days.map((d) => ({ date: d.date, label: d.label, value: d.minutes }));

  return (
    <section className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm mb-6">
      <header className="flex items-center justify-between gap-3 mb-4">
        <div>
          <h2 className="text-sm font-bold text-foreground">Last two weeks</h2>
          <p className="text-xs text-muted-foreground mt-0.5 font-medium">
            {total > 0
              ? `${formatMinutes(total)} across ${activeDays} day${activeDays === 1 ? '' : 's'}`
              : 'No study time recorded yet'}
          </p>
        </div>
        <button
          onClick={() => navigate(urlLanguage('/analytics?tab=learning'))}
          className="flex items-center gap-1 text-[11px] font-bold text-primary bg-transparent border-none cursor-pointer hover:underline"
        >
          Full history <ChevronRight className="w-3 h-3" />
        </button>
      </header>

      {total > 0 ? (
        <TimeColumns data={data} height={160} valueLabel="Studied" format={formatMinutes} />
      ) : (
        <div className="h-[160px] flex flex-col items-center justify-center text-center gap-1">
          <p className="text-sm font-semibold text-foreground">Nothing tracked yet</p>
          <p className="text-xs text-muted-foreground">Open a material — your reading time lands here.</p>
        </div>
      )}
    </section>
  );
};

export default ActivityStrip;
